import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removeSectorsSettings } from '@api/sectors';

import { ESnackbarTypes } from '@enums/common';

import { ALL_SECTORS, DELETE_SECTORS_SETTINGS, SECTOR_SETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeleteSectorsSettings = (onSuccessCallback: () => void): {
	deleteSectorsSettings: (id: string) => void;
	isDeletingSectorSettings: boolean;
} => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: deleteSectorsSettings,
		isLoading,
	} = useMutation<string>({
		mutationKey: [DELETE_SECTORS_SETTINGS],
		mutationFn: removeSectorsSettings,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.deleteSectorsSettings,
				type: ESnackbarTypes.success,
			}));

			onSuccessCallback();

			return [
				queryClient.invalidateQueries([SECTOR_SETS]),
				queryClient.invalidateQueries([ALL_SECTORS]),
			];
		},
	});

	return {
		deleteSectorsSettings,
		isDeletingSectorSettings: isLoading,
	};
};
